module.exports = __webpack_public_path__ + "static/banner-en-ba0e92ee79cc33d706a19cc819dd7e65.png";